/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SpaceId } from "../../commons/types/SpaceId";
import { StoredConstraint } from "../../property/types/StoredConstraint";
export const AiGenerateConstraintJobConfig = core.serialization.object({
    spaceId: SpaceId,
    constraints: core.serialization.list(StoredConstraint),
    description: core.serialization.string().optional(),
});
